import { WalletConversionErrorDto, WalletConversionErrorModel } from '../types/wallet-conversion'

export const transformWalletConversionError = ({
  title,
  body,
  button_title,
  button_url,
  close_button_title,
}: WalletConversionErrorDto): WalletConversionErrorModel => ({
  title,
  body,
  buttonTitle: button_title,
  buttonUrl: button_url,
  closeButonTitle: close_button_title,
})
